import { Client, type Room, Callbacks } from "@colyseus/sdk";
import { SERVER_URL } from "../config";

export interface InputMsg {
  seq: number;
  fwd: number;
  turn: number;
  aim: number;
  aimDist: number;
  fire: boolean;
}

export interface ConnectOptions {
  name: string;
  mode: string;
  action: "create" | "join";
  code?: string;
  classId?: string;
}

/** Reactive state handler. The client treats room state as an opaque proxy. */
export interface StateCallbacks {
  onAdd(field: string, cb: (value: any, key: string) => void): unknown;
  onRemove(field: string, cb: (value: any, key: string) => void): unknown;
  listen(instance: any, field: string, cb: (current: any, previous: any) => void): unknown;
}

/**
 * Wraps the Colyseus client SDK. Supports creating a room (returns a code) or
 * joining an existing one by code.
 */
export class NetworkClient {
  readonly client: Client;
  room: Room | null = null;
  callbacks: StateCallbacks | null = null;
  sessionId = "";

  constructor() {
    this.client = new Client(SERVER_URL);
  }

  get roomId(): string {
    return this.room?.roomId ?? "";
  }

  async connect(opts: ConnectOptions): Promise<void> {
    const joinOpts = { name: opts.name, classId: opts.classId };
    if (opts.action === "join" && opts.code) {
      this.room = await this.client.joinById(opts.code, joinOpts);
    } else {
      this.room = await this.client.create("arena", { name: opts.name, mode: opts.mode, classId: opts.classId });
    }
    this.sessionId = this.room.sessionId;
    this.callbacks = Callbacks.get(this.room) as unknown as StateCallbacks;
    console.log(`[net] room ${this.room.roomId} joined as ${this.sessionId}`);
  }

  sendInput(seq: number, fwd: number, turn: number, aim: number, aimDist: number, fire: boolean): void {
    this.room?.send("input", { seq, fwd, turn, aim, aimDist, fire });
  }

  /** Request the class special (server validates + applies). */
  sendAbility(): void {
    this.room?.send("ability", {});
  }
}
